<template>
  <div class="index_wrap" >
    <img src="./img/1.png" class="icon" />
    <div class="text" >您的资料已提交，平台审核中。</div>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
export default {
  name: 'success',
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>
